import { render, staticRenderFns } from "./WorkspaceList.vue?vue&type=template&id=72841f78&scoped=true"
import script from "./WorkspaceList.vue?vue&type=script&lang=js"
export * from "./WorkspaceList.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceList.vue?vue&type=style&index=0&id=72841f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72841f78",
  null
  
)

export default component.exports